
export function isMapIterator<K, V>(
    value: unknown
): value is IterableIterator<[K, V]> {
    return (
        value !== null &&
        typeof value === "object" &&
        typeof (value as any).next === "function" &&
        typeof (value as any)[Symbol.iterator] === "function"
    );
}

type RawData = {
    field: number,
    value: any
}

export function mergeRow(
    prev: RawData[] = [],
    incoming: RawData[]
): RawData[] | null {
    try {
        const map = new Map<number, RawData>((prev || []).map(d => [d.field, d]));
        let changed = false;
        for (const d of incoming) {
            const old = map.get(d.field);
            if (!old || old.value !== d.value) {
                map.set(d.field, d);          // add or overwrite
                changed = true;
            }
        }
        // Return the original array instance when nothing changed
        return changed ? Array.from(map.values()) : prev;
    }catch(ex) {
        debugger;
        return null;
    }
}

